import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./ObjectivePerson.css";

function ObjectivePerson({
  id,
  firstName,
  lastName,
  profileName,
  profileNameEnglish,
  language,
}) {
  const navigate = useNavigate();

  return (
    <Row className="objective-person align-items-center">
      <Col className="objective-person-header">
        <h5 onClick={() => navigate(`/myobjectives/person/${id}`)}>
          {firstName} {lastName}
        </h5>
        <p>{language === "es" ? profileName : profileNameEnglish}</p>
      </Col>
    </Row>
  );
}

export default ObjectivePerson;
